// Library
import React from 'react';
import { Box, BoxPart } from 'components/box';
import { __t, applyTranslations } from 'utils/language';

applyTranslations(require('./not-found.i18n.json'));

const NotFound = () => (
  <Box bordered>
    <BoxPart
      align="center"
      paddings="equal"
    >
      <section data-qa="page-not-found">
        <h1>404</h1>
        <p>
          {__t('not_found.page_text')}
        </p>
      </section>
    </BoxPart>
  </Box>
);

export default NotFound;
